
import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import MentorsSection from "@/components/MentorsSection";
import { useIsMobile } from "@/hooks/use-mobile";

const Mentors = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className="flex-grow">
        <div className={`container mx-auto px-4 ${isMobile ? "py-8" : "py-12"}`}>
          <h1 className={`${isMobile ? "text-2xl" : "text-3xl"} font-bold mb-6`}>
            Connect with Mentors
          </h1>
          <p className="text-muted-foreground mb-12">
            Find mentors who can guide you on your journey and help you achieve your goals.
          </p>
        </div>
        <MentorsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Mentors;
